import { render, staticRenderFns } from "./face.vue?vue&type=template&id=98b98f96&scoped=true"
import script from "./face.vue?vue&type=script&lang=js"
export * from "./face.vue?vue&type=script&lang=js"
import style0 from "./face.vue?vue&type=style&index=0&id=98b98f96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b98f96",
  null
  
)

export default component.exports